import instance from './axios';
import React, { useEffect, useState } from 'react';
import requests from './Request';
import './Banner.css';

function Banner() {
    const [movie, setMovie] = useState([]);

    useEffect(()=>{
        async function fetchData() {
            const request = await instance.get(requests.fetchNetflixOriginals);
            setMovie(
                request.data.results[Math.floor(Math.random()*(request.data.results.length - 1))]
            );
            return request;
        }
        fetchData();
    },[]);

    console.log(movie);

    function truncate(str, length) {
        if (str?.length > length) {
            return str?.substring(0, length) + "...";
        } else {
            return str;
        }
    }

    return(
        <header className='banner'
        style={{
            backgroundSize: "cover",
           backgroundImage: `url(http://image.tmdb.org/t/p/original/${movie?.backdrop_path})`,
           backgroundPosition: "center center"
        }}
        >
            <div className='banner-content'>
                <h1 className='banner-title'>{movie?.title || movie?.name || movie?.original_name }</h1>
                <div className='banner_buttons'>
                    <button className='banner-button'>Play</button>
                    <button className='banner-button'>My List</button>
                </div>
                <h1 className='banner-description'>
                    {truncate(movie?.overview, 150)}
                </h1>
            </div>
            <div className='banner-fade'></div>
        </header>
    )
}

export default Banner;
